export const routeProps = {
  path: '/addresses/:addressId?/:action?',
  exact: true,
};

export default ({ addressId, packId = '' } = {}, action = 'list', options) => {
  const actionsMap = {
    list: '/addresses',
    set: `/addresses/${addressId}/set?packId=${packId}`,
    add: `/addresses/__/add${options && options.search ? options.search : ''}`,
    changeDefault: '/addresses/__/changeDefault',
    delete: `/addresses/${addressId}/delete`,
  };
  return actionsMap[action];
};
